export default __webpack_public_path__ + "static/media/mba.e7f6aedc.jpg";